import { useIntl } from "react-intl";
import "./styles.scss";

export type Tab = "franquia" | "saldo" | "revisoes";

export interface ITabsProps {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
  hasTruckerPayPlan?: boolean;
  hasVolksEssentialsPlan?: boolean;
}

const Tabs = ({ activeTab, onTabChange, hasTruckerPayPlan, hasVolksEssentialsPlan }: ITabsProps) => {
  const intl = useIntl();

  return (
    <section className="margin-bottom-20 contract-details-tabs-wrap">
      <div className="contract-details-tabs">
        {hasTruckerPayPlan ? (
          <>
            <button
              type="button"
              onClick={() => onTabChange("franquia")}
              className={`contract-details-tabs__btn ${activeTab === "franquia" ? "contract-details-tabs__btn--active" : ""}`}
            >
              {intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.tabs.franquia" })}
            </button>
            <button
              type="button"
              onClick={() => onTabChange("saldo")}
              className={`contract-details-tabs__btn ${activeTab === "saldo" ? "contract-details-tabs__btn--active" : ""}`}
            >
              {intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.tabs.saldo" })}
            </button>
          </>
        ) : hasVolksEssentialsPlan ? (
          <>
            <button
              type="button"
              onClick={() => onTabChange("revisoes")}
              className={`contract-details-tabs__btn ${activeTab === "revisoes" ? "contract-details-tabs__btn--active" : ""}`}
            >
              {intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.tabs.revisoes" })}
            </button>
          </>
        ) : null}
      </div>
    </section>
  );
};

export default Tabs;
